module.exports = __webpack_public_path__ + "static/media/img-04.51916bcb.jpg";